import React from 'react';

const ActivityPriceSummary = ({
    bookingData,
    transactionCharges,
    paymentType,
    getHikedPrice,
    resetOffers,
    setNavDetails
}) => {
    return (
        <>
            {bookingData.amountPaid?.isReserved ? (
                <div className='tripBookDataInput'>
                    <div className='tripPriceCal'>
                        <p className='tripBookPrice'>₹{bookingData?.reserveTotal}</p>

                        <p className='tripBookPrice'>₹{bookingData?.reserveTotal}</p>
                    </div>

                    {bookingData.offerCode && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Offer</p>

                            <p className='tripBookOfferText'>- ₹{bookingData?.offerAmo}</p>
                        </div>
                    )}

                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Convenience Fee</p>

                        <p className='tripBookOfferText'>+ ₹{transactionCharges}</p>
                    </div>

                    {paymentType === 'UPI' && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>UPI Offers</p>

                            <p className='tripBookOfferText'>- ₹{transactionCharges}</p>
                        </div>
                    )}

                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>Total:</p>

                        <p className='tripBookTotalText'>
                            ₹{bookingData?.reserveTotal + (paymentType === 'UPI' ? 0 : bookingData.convinienceFee)}
                        </p>
                    </div>

                    <span />

                    <button
                        type='button'
                        className='reviewBoSumChangeBtn grayBtn'
                        onClick={() => {
                            resetOffers();
                            setNavDetails(true);
                        }}
                    >
                        Change Details
                    </button>
                </div>
            ) : bookingData.amountPaid?.isInstallment ? (
                <div className='tripBookDataInput'>
                    <div className='tripPriceCal'>
                        <p className='tripBookPrice'>
                            ₹{bookingData?.installmentPrice} x {bookingData?.people}
                        </p>

                        <p className='tripBookPrice'>₹{bookingData?.peopleAmo}</p>
                    </div>

                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Convenience Fee</p>

                        <p className='tripBookOfferText'>+ ₹{transactionCharges}</p>
                    </div>

                    {paymentType === 'UPI' && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>UPI Offers</p>

                            <p className='tripBookOfferText'>- ₹{transactionCharges}</p>
                        </div>
                    )}

                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>Total:</p>

                        <p className='tripBookTotalText'>₹{bookingData.totalAmo}</p>
                    </div>

                    <span />

                    <button
                        type='button'
                        className='reviewBoSumChangeBtn grayBtn'
                        onClick={() => {
                            resetOffers();
                            setNavDetails(true);
                        }}
                    >
                        Change Details
                    </button>
                </div>
            ) : (
                <div className='tripBookDataInput'>
                    <div className='tripPriceCal'>
                        <p className='tripBookPrice'>₹{getHikedPrice(bookingData.amountPaid.actual)}</p>

                        <p className='tripBookPrice'>₹{getHikedPrice(bookingData.amountPaid.actual)}</p>
                    </div>

                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Discount</p>

                        <p className='tripBookOfferText'>- ₹{bookingData.amountPaid.discount}</p>
                    </div>

                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Tax</p>

                        <p className='tripBookOfferText'>+ ₹{bookingData.amountPaid.tax}</p>
                    </div>

                    {(bookingData?.offerAmo > 0 || bookingData.offerCode) && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>Offer</p>

                            <p className='tripBookOfferText'>- ₹{bookingData?.offerAmo}</p>
                        </div>
                    )}

                    <div className='tripBookOfferDiv'>
                        <p className='tripBookOfferText'>Convenience Fee</p>

                        <p className='tripBookOfferText'>+ ₹{transactionCharges}</p>
                    </div>

                    {paymentType === 'UPI' && (
                        <div className='tripBookOfferDiv'>
                            <p className='tripBookOfferText'>UPI Offers</p>

                            <p className='tripBookOfferText'>- ₹{transactionCharges}</p>
                        </div>
                    )}

                    <div className='tripBookTotalDiv'>
                        <p className='tripBookTotalText'>Total:</p>

                        <p className='tripBookTotalText'>
                            ₹
                            {bookingData.amountPaid.total -
                                (bookingData?.offerAmo ? bookingData?.offerAmo : 0) +
                                (paymentType === 'UPI' ? 0 : bookingData.convinienceFee)}
                        </p>
                    </div>

                    <span />

                    <button
                        type='button'
                        className='reviewBoSumChangeBtn grayBtn'
                        onClick={() => {
                            resetOffers();
                            setNavDetails(true);
                        }}
                    >
                        Change Details
                    </button>
                </div>
            )}
        </>
    );
};

export default ActivityPriceSummary;
